// NoteDialogContainer.tsx - This component handles the connection between Redux and the dialog
import React from 'react';
import { useAppSelector, useAppDispatch } from 'src/hooks';
import { closeNoteDialog, 
    openNoteDialog, 
    updateNoteInState } from '../../features/table/store/note-slice';
import NoteDialog from './note-dialog';
import { addScenarioManagerComment } from '../../../scenario-manager/scenario-manager-slice';
import {useState} from 'react';
import { updateClusterSummaryNote } from '../../../cluster-summary/store/cluster-summary-slice';
import { updateScenarioManagerNote } from '../../../scenario-manager/scenario-manager-slice';

interface NoteDialogContainerProps {
  sourceId: number; 
  isScenarioManager?: boolean;
}

const NoteDialogContainer: React.FC<NoteDialogContainerProps> = ({ sourceId, isScenarioManager}) => {
  const dispatch = useAppDispatch();
  const { isVisible, currentScenario } = useAppSelector((state) => state.noteDialog);
  
  const handleClose = () => {
    dispatch(closeNoteDialog());
  };

  const handleSend = async (note: string) => {
    if (!currentScenario?.scenario_id || !note.trim()) {
      return;
    }

    try {
       const response = await dispatch(addScenarioManagerComment({
        sourceId: sourceId,
        scenarioId: currentScenario.scenario_id,
        comment_text: note.trim(),
      })).unwrap();

      dispatch(updateNoteInState({
          scenario_id: currentScenario.scenario_id,
          note_text: response?.comment_text,
          note_user: response?.comment_user_name,
          note_updated_at: response?.created_at,
          note_pk_id: response?.pk_id,
        }));
       if (isScenarioManager) {
        dispatch(updateScenarioManagerNote({
          scenario_id: currentScenario.scenario_id,
          noteData: {
            pk_id: response?.pk_id,
            comment_text: response?.comment_text,
            comment_user: response?.comment_user,
            comment_user_name: response?.comment_user_name,
            created_at: response?.created_at,
            updated_at: response?.updated_at || response?.created_at,
            is_edited: false
          }
        }));
      } else {
        dispatch(updateClusterSummaryNote({
          scenario_id: currentScenario.scenario_id,
          source_id:sourceId,
          noteData: {
            pk_id: response?.pk_id,
            comment_text: response?.comment_text,
            comment_user: response?.comment_user,
            comment_user_name: response?.comment_user_name,
            created_at: response?.created_at,
            updated_at: response?.updated_at || response?.created_at,
            is_edited: false
          }
        }));
      }
      handleClose();
    } catch (error) {
      console.error('Failed to send note:', error);
    }
  };

  if (!isVisible || !currentScenario) {
    return null;
  }
  
  return (
    <NoteDialog
      initialNote={currentScenario.note_text || ''}
      user_name={currentScenario.note_user || ''}
      updated_at={currentScenario.note_updated_at || ''}
      open={isVisible}
      onClose={handleClose}
      onSend={handleSend}
    />
   
  );
};

export default NoteDialogContainer;



